import { jsx as n } from "react/jsx-runtime";
import { useState as m, useEffect as v } from "react";
import { propagateTestid as f, stringReplacer as h } from "../../utils/helpers.js";
const M = "ids-progress-v501", S = "ids-progress--indicator-v501", c = {
  progress: M,
  indicator: S
}, x = ({
  max: r = 100,
  min: e = 0,
  sectionTitle: d = "Progress is {{current}} of {{max}}",
  value: t = 0,
  "data-testid": a,
  ...l
}) => {
  const [o, p] = m(t), g = `${Math.round((t - e) / (r - e) * 100).toString()}%`, i = () => {
    const s = [
      { name: "{{current}}", value: o.toString() },
      { name: "{{max}}", value: r.toString() }
    ];
    return h(d, s);
  };
  return v(() => {
    const s = Math.max(t, e), u = Math.min(s, r);
    p(u);
  }, [t, e, r]), /* @__PURE__ */ n("div", { ...l, "data-testid": a, className: c.progress, children: /* @__PURE__ */ n(
    "div",
    {
      "aria-valuetext": i(),
      "aria-valuemax": r,
      "aria-valuemin": e,
      "aria-valuenow": o,
      "aria-label": i(),
      className: c.indicator,
      role: "progressbar",
      "data-testid": f(a, "progressbar"),
      style: {
        width: g
      }
    }
  ) });
}, N = x;
export {
  N as IressProgress
};
